import { type LearningSystemExplainerVisual } from './types'
import { ProgramVisual } from './visuals/ProgramVisual'
import { ResourceVisual } from './visuals/ResourceVisual'
import { RouteVisual } from './visuals/RouteVisual'
import { SystemVisual } from './visuals/SystemVisual'
import { TopicVisual } from './visuals/TopicVisual'

export function LearningSystemVisual({
	visual,
	idPrefix,
}: {
	visual: LearningSystemExplainerVisual
	idPrefix: string
}) {
	switch (visual) {
		case 'system':
			return <SystemVisual />
		case 'program':
			return <ProgramVisual idPrefix={idPrefix} />
		case 'itinerary':
			return <ProgramVisual idPrefix={idPrefix} />
		case 'route':
			return <RouteVisual />
		case 'topic':
			return <TopicVisual idPrefix={idPrefix} />
		case 'resource':
			return <ResourceVisual idPrefix={idPrefix} />
		default:
			return <SystemVisual />
	}
}
